import React from 'react';

const ScorePanel = ({ playerScore, playerColor, aiScore, aiColor, isPlayerTurn }) => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "20px"
    }}>
      <div style={{
        padding: "10px",
        background: "#F0F0F0",
        borderRadius: "5px",
        border: isPlayerTurn ? "2px solid #333" : "2px solid transparent"
      }}>
        <strong>Player:</strong> {playerScore} tiles
        <div style={{
          width: "20px",
          height: "20px",
          backgroundColor: playerColor,
          margin: "5px auto"
        }}></div>
      </div>
      <div style={{
        padding: "10px",
        background: "#F0F0F0",
        borderRadius: "5px",
        border: !isPlayerTurn ? "2px solid #333" : "2px solid transparent"
      }}>
        <strong>AI:</strong> {aiScore} tiles
        <div style={{
          width: "20px",
          height: "20px",
          backgroundColor: aiColor,
          margin: "5px auto"
        }}></div>
      </div>
    </div>
  );
};

export default ScorePanel;